import {
  authReq
} from '@/utils/http'

const getUsers = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const getAreas = (page, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user/area', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const getStores = (page, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/user/store', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

export default {
  getUsers,
  getAreas,
  getStores
}



// WEBPACK FOOTER //
// ./src/api/userApi.js